import {readSpecAndInitModule} from './read-spec-and-init-module';
import {readModuleSpecs} from './read-module-specs';
import {getModuleSpecs} from './get-modules-specs';

export function initModules(el, force) {
    const alreadyInitializedModules = el.hop ? el.hop.map((mod) => mod.id) : [];

    readModuleSpecs(getModuleSpecs(el)).forEach((spec) => {
        if (alreadyInitializedModules.includes(spec.obj) && force !== true) {
            return;
        }

        try {
            if (readSpecAndInitModule(el, spec)) {
                alreadyInitializedModules.push(spec.obj);
            }
        } catch (err) {
            Hop.logError(
                'Could not init module for element '
                + Hop.describeDomElement(el)
                + ': '
                + JSON.stringify(spec)
                + ' (see error detail in next log)',
            );
            Hop.logError(err);
        }
    });
}
